var React = require('react');

function IcBookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.33374 1H16.6667C17.5811 1 18.3337 1.75261 18.3337 2.66699V22.4834L10.3943 19.0811L9.99976 18.9121L9.6062 19.0811L1.66675 22.4824L1.68042 2.66699L1.68823 2.49609C1.77348 1.65537 2.48263 1 3.33374 1Z","stroke":"currentColor","strokeWidth":"2"}));
}

IcBookmark.defaultProps = {"width":"20","height":"24","viewBox":"0 0 20 24","fill":"none"};

module.exports = IcBookmark;

IcBookmark.default = IcBookmark;
